import React from "react";
import I18n from "i18n-js";
import IconTooltip from "./IconTooltip";
import { getHtmlElement, parseUserFullName, titleize } from "../../utils/utils";
import CopyButton from "./CopyButtonComponent";

const Address = ({
  address,
  email,
  note,
  hidePhoneNumber,
  displayFullNotes,
  renderResidence,
  hideUserGeneralities,
  renderCopyButton,
  renderTitle,
  locale,
  addressType,
  layout
}) => {

  const addressText = `${titleize(address?.street_square)} ${address?.number}${address?.indoor ? (' ' + I18n.t('js.newUserAddressForm.indoor', { locale: locale ? locale : I18n.locale }) + ' ' + address?.indoor) : ''}`
  const userFullName = parseUserFullName(address?.first_name, address?.last_name);
  const co = I18n.t('js.newUserAddressForm.co', { locale: locale ? locale : I18n.locale }) + ' ' + address?.co;
  const city = `${address?.city?.toUpperCase() !== address?.province?.toUpperCase() ? titleize(address?.city) + ' - ' : ''}${address?.province?.toUpperCase()}`

  const RenderTitle = ({ title, fragment }) => {
    if (renderTitle) {
      return (
        layout === 'grid_left' ?
          <React.Fragment>
            <div className="col-4 text-right color-gray-4 pt-3 pb-1">
              {title}
            </div>
            <div className="col-8 px-0 pt-3 pb-1">
              {fragment}
            </div>
          </React.Fragment>
          :
          <div className="row">
            <div className="col-6">
              <b>
                {title}
              </b>
            </div>
            <div className="col-6 pl-0">
              {fragment}
            </div>
          </div>
      )
    } else {
      return (
        <React.Fragment>
          {fragment}
          <br />
        </React.Fragment>
      )
    }
  }


  return <React.Fragment>
    {
      !hideUserGeneralities &&
      <React.Fragment>
        {
          address?.residence && renderResidence &&
          <React.Fragment>
            <RenderTitle
              title=''
              fragment={
                <React.Fragment>
                  <b id={`residence_${addressType}`} className="mb-0">
                    {I18n.t('js.newUserAddressForm.residenceCompact')}
                  </b>
                </React.Fragment>
              }
            />
          </React.Fragment>
        }

        <RenderTitle
          title='Recipient'
          fragment={
            <React.Fragment>
              <span className="mb-0" id={`user_generalities_${addressType}`}>
                {userFullName}
                {
                  address?.co &&
                  <React.Fragment>
                    &nbsp;
                    <span className="mb-0">
                      {co}
                    </span>
                  </React.Fragment>
                }
              </span>
              {renderCopyButton &&
                <CopyButton
                  text={`${userFullName}${address?.co ? co : ''}`}
                  iconClassName={'ml-2'}
                />
              }
            </React.Fragment>
          }
        />
      </React.Fragment >
    }

    <RenderTitle
      title='Address'
      fragment={
        <React.Fragment>
          <span className="mb-0" id={`street_${addressType}`}>
          {addressText}
          </span>
          {renderCopyButton &&
            <CopyButton
              text={addressText}
              iconClassName={'ml-2'}
            />
          }
        </React.Fragment>
      }
    />

    <RenderTitle
      title='CAP, City, Province, Country'
      fragment={
        <React.Fragment>
          <span className="mb-0" id={`cap_${addressType}`}>
            {address?.cap}
          </span>
          {renderCopyButton &&
            <CopyButton
              text={address?.cap}
              iconClassName={'ml-2'}
            />
          }
          <span className="mb-0 ml-2" id={`city_${addressType}`}>
            {city}
          </span>
          {renderCopyButton &&
            <CopyButton
              text={city}
              iconClassName={'ml-2'}
            />
          }
          {
            address?.country?.toUpperCase() !== address?.province?.toUpperCase() &&
            <React.Fragment>
              <span className="mb-0 ml-2" id={`country_${addressType}`}>
                ({address?.country?.toUpperCase()})
              </span>
              {renderCopyButton &&
                <CopyButton
                  text={address?.country?.toUpperCase()}
                  iconClassName={'ml-2'}
                />
              }
            </React.Fragment>
          }
        </React.Fragment>
      }
    />

    {
      address?.phone_number && !hidePhoneNumber &&
      <React.Fragment>
        <RenderTitle
          title='Phone Number'
          fragment={
            <React.Fragment>
              <span id={`phone_number_${addressType}`}>
                {address?.phone_number}
              </span>
              {renderCopyButton &&
                <CopyButton
                  text={address?.phone_number}
                  iconClassName={'ml-2'}
                />
              }
            </React.Fragment>
          }
        />
      </React.Fragment>
    }


    {
      (address?.email || email) &&
      <React.Fragment>
        <RenderTitle
          title='Email'
          fragment={
            <React.Fragment>
              <span id={`email_${addressType}`}>
                {address?.email ? address?.email : email}
              </span>
              {renderCopyButton &&
                <CopyButton
                  text={address?.email ? address?.email : email}
                  iconClassName={'ml-2'}
                />
              }
            </React.Fragment>
          }
        />
      </React.Fragment>
    }


    {
      note &&
      <React.Fragment>
        <RenderTitle
          title='Notes'
          fragment={
            displayFullNotes ?
              <React.Fragment>
                <span id={`note_${addressType}`}>
                  {I18n.t('js.newUserAddressForm.noteForCourierCompact', { locale: locale ? locale : I18n.locale })} {note}
                </span>
                {renderCopyButton &&
                  <CopyButton
                    text={`${I18n.t('js.newUserAddressForm.noteForCourierCompact', { locale: locale ? locale : I18n.locale })} ${note}`}
                    iconClassName={'ml-2'}
                  />
                }
              </React.Fragment>
              :
              <React.Fragment>
                <span id={`note_${addressType}`}>
                  <small>{I18n.t('js.newUserAddressForm.noteForCourierCompact', { locale: locale ? locale : I18n.locale })}</small>
                  <IconTooltip
                    tooltipPosition={'top'}
                    tooltipIcon={'fas fa-comment'}
                    tooltipTitle={''}
                    tooltipContent={note}
                    additionalClassesForIcon={'black'}
                  />
                </span>
                {renderCopyButton &&
                  <CopyButton
                    text={I18n.t('js.newUserAddressForm.noteForCourierCompact', { locale: locale ? locale : I18n.locale })}
                    iconClassName={'ml-2'}
                  />
                }
              </React.Fragment>
          }
        />
      </React.Fragment>
    }
  </React.Fragment >
};

export default Address;